export const LISTING = 'list'
export const TRANSACTION = 'transaction'
export const APPROVAL_LIST = 'approval_list'
export const ADD_MONEY = 'add_money'
export const APPROVAL_LIST_DATA = 'APPROVAL_LIST_DATA'
export const VIEW_REQUEST = 'VIEW_REQUEST'
export const REQUEST_ACTION = 'REQUEST_ACTION'
export const WALLET_FINANCE_REQUEST = 'WALLET_FINANCE_REQUEST'
export const REQUEST_TRANSACTION_LIST = 'REQUEST_TRANSACTION_LIST'
export const WALLET_REQUEST_LIST = 'WALLET_REQUEST_LIST'
export const FETCH_DEALER_DATA = 'FETCH_DEALER_DATA'
export const LISTING_DEALER = 'LISTING_DEALER'
export const LISTING_DEALER_APPROVAL = 'LISTING_DEALER_APPROVAL'
